import LandingLayout from "./LandingLayout";
import { MdPhone, MdEmail, MdLocationOn } from "react-icons/md";

const LandingContacto = () => {
    // Static data provided by user
    const phone = "+56 9 8249 3665";
    const email = "mantencion@asesoriastecnicas.com";
    const address = "Calle Sevilla 1844 – Padre Hurtado – Santiago";
    const companyName = "Asesorías Técnicas S.A.";


    return (
        <LandingLayout>
            <div className="bg-gray-50 py-16 lg:py-24 min-h-screen">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <h2 className="text-amber-600 font-bold tracking-wide uppercase mb-2">Estamos para Ayudarle</h2>
                        <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">Contacto Profesional</h1>
                        <p className="mt-4 text-xl text-gray-500 max-w-2xl mx-auto">Comuníquese con nosotros para cotizaciones y consultas técnicas.</p>
                    </div>

                    <div className="grid lg:grid-cols-2 gap-12 bg-white rounded-3xl shadow-xl overflow-hidden">
                        {/* Contact Info Side */}
                        <div className="bg-gray-900 p-10 lg:p-16 text-white flex flex-col justify-between">
                            <div>
                                <h3 className="text-3xl font-bold mb-8">Información Directa</h3>
                                <p className="text-gray-400 mb-12 text-lg">
                                    {companyName} está disponible para atender sus requerimientos a la brevedad.
                                </p>

                                <div className="space-y-8">
                                    <div className="flex items-center gap-6">
                                        <div className="w-12 h-12 bg-amber-600 rounded-full flex items-center justify-center shadow-lg shadow-amber-900/40"><MdPhone size={24} /></div>
                                        <div>
                                            <p className="text-amber-500 font-bold text-sm uppercase tracking-wider">Llámenos</p>
                                            <p className="font-semibold text-xl">{phone}</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-6">
                                        <div className="w-12 h-12 bg-amber-600 rounded-full flex items-center justify-center shadow-lg shadow-amber-900/40"><MdEmail size={24} /></div>
                                        <div>
                                            <p className="text-amber-500 font-bold text-sm uppercase tracking-wider">Escríbanos</p>
                                            <p className="font-semibold text-xl break-all">{email}</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-6">
                                        <div className="w-12 h-12 bg-amber-600 rounded-full flex items-center justify-center shadow-lg shadow-amber-900/40"><MdLocationOn size={24} /></div>
                                        <div>
                                            <p className="text-amber-500 font-bold text-sm uppercase tracking-wider">Visítenos</p>
                                            <p className="font-semibold text-xl">{address}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-16 pt-8 border-t border-gray-800">
                                <p className="text-gray-500 text-sm">Horario de Atención: Lunes a Viernes, 08:30 - 18:30 hrs.</p>
                            </div>
                        </div>

                        {/* Form Side */}
                        <div className="p-10 lg:p-16 bg-white">
                            <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
                                <div className="grid md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">Nombre</label>
                                        <input type="text" className="w-full px-4 py-4 rounded-xl bg-gray-50 border border-gray-200 focus:border-amber-500 focus:ring-2 focus:ring-amber-200 transition-all outline-none" placeholder="Juan Pérez" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">Teléfono</label>
                                        <input type="tel" className="w-full px-4 py-4 rounded-xl bg-gray-50 border border-gray-200 focus:border-amber-500 focus:ring-2 focus:ring-amber-200 transition-all outline-none" placeholder="+56 9..." />
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">Empresa</label>
                                    <input type="text" className="w-full px-4 py-4 rounded-xl bg-gray-50 border border-gray-200 focus:border-amber-500 focus:ring-2 focus:ring-amber-200 transition-all outline-none" placeholder="Nombre de su organización" />
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">Correo Electrónico</label>
                                    <input type="email" className="w-full px-4 py-4 rounded-xl bg-gray-50 border border-gray-200 focus:border-amber-500 focus:ring-2 focus:ring-amber-200 transition-all outline-none" placeholder="ejemplo@correo.com" />
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">Mensaje</label>
                                    <textarea rows="4" className="w-full px-4 py-4 rounded-xl bg-gray-50 border border-gray-200 focus:border-amber-500 focus:ring-2 focus:ring-amber-200 transition-all outline-none" placeholder="Detalle su requerimiento..."></textarea>
                                </div>
                                <button className="w-full py-5 bg-gray-900 text-white font-bold text-lg rounded-xl hover:bg-black transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-1">
                                    Enviar Mensaje
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </LandingLayout>
    );
};

export default LandingContacto;
